import { immerable } from 'immer';

import dayjs from '../../../core/configs/dayjs';

interface ITraceItemEntity {
	id: number;
	action: string;
	elementLabel: string;
	elementUrl: string;
	modificationDate: dayjs.Dayjs;
	modifiedBy: string;
}

const entityDefaults: ITraceItemEntity = {
	id: -1,
	action: '',
	elementLabel: '',
	elementUrl: '',
	modificationDate: dayjs(),
	modifiedBy: '',
};

export class ProjectTraceItemEntity implements ITraceItemEntity {
	private [immerable] = true;
	public id = entityDefaults.id;
	public action = entityDefaults.action;
	public elementLabel = entityDefaults.elementLabel;
	public elementUrl = entityDefaults.elementUrl;
	public modificationDate = entityDefaults.modificationDate;
	public modifiedBy = entityDefaults.modifiedBy;

	public static build(
		params: Partial<ITraceItemEntity> = {}
	): ProjectTraceItemEntity {
		const instance = new ProjectTraceItemEntity();
		instance.id = params.id ?? entityDefaults.id;
		instance.action = params.action ?? entityDefaults.action;
		instance.elementLabel = params.elementLabel ?? entityDefaults.elementLabel;
		instance.elementUrl = params.elementUrl ?? entityDefaults.elementUrl;
		instance.modifiedBy = params.modifiedBy ?? entityDefaults.modifiedBy;
		instance.modificationDate =
			params.modificationDate ?? entityDefaults.modificationDate;

		return instance;
	}
}
